import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import Button from '../Common/Button';
import crm1 from '../../assets/crm/crm1.png';
import './PromoBanner.css';

const PromoBanner = () => {
  return (
    <section className="promo-banner">
      <div className="container">
        <div className="promo-banner-content">
          <motion.div
            className="promo-banner-text"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <motion.h2
              className="promo-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              Şirketinizi{' '}
              <span className="promo-brand">FlowSky CRM</span> ile tanıştıralım mı?
            </motion.h2>

            <motion.p
              className="promo-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Şirketinizin bir CRM'den daha fazlası FlowSky CRM ile tanışması sadece bir tık uzaklıkta. 
              Hemen 14 günlük denemenizi başlatın.
            </motion.p>

            <motion.div
              className="promo-cta"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <Button to="/iletisim" variant="primary" size="large" className="promo-btn-primary">
                Demo Talep Edin
                <FaArrowRight />
              </Button>
            </motion.div>
          </motion.div>

          <motion.div
            className="promo-banner-visual"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="laptop-mockup-wrapper">
              <div className="device-mockup laptop-mockup">
                <div className="device-screen">
                  <img src={crm1} alt="FlowSky CRM Dashboard" />
                </div>
              </div>
              <motion.div
                className="laptop-label"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.7 }}
              >
                Web Deneyimi
              </motion.div>
            </div>
            <div className="phone-mockup-wrapper">
              <div className="device-mockup phone-mockup">
                <div className="device-screen">
                  <img src={crm1} alt="FlowSky CRM Mobile" />
                </div>
              </div>
              <motion.div
                className="mobile-label"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
              >
               Mobil Deneyim
              </motion.div>
            </div>
            <div className="promo-gradient"></div>
          </motion.div>
        </div>
      </div>
      <div className="promo-wave-divider"></div>
    </section>
  );
};

export default PromoBanner;

